import { Pipe, PipeTransform } from "@angular/core";
import { TransactionType, TransactionTypeLabel, TransactionTypeString, TransactionTypeStringLabel } from "./transaction.model";

@Pipe({
    name: "transactionTypeName",
    standalone: false
})
export class TransactionTypeNamePipe implements PipeTransform {
  transform(value: TransactionTypeString | TransactionType): string {
    if (typeof value === 'string') {
      return TransactionTypeStringLabel.get(value) || 'Unknown';
    }

    if (typeof value === 'number') {
      return TransactionTypeLabel.get(value) || 'Unknown';
    }

    return 'Unknown';
  }
}
